export default class CatalogCategories {
    constructor() {
        this.sideCategoriesContainer = document.querySelector('.catalog-categories-side');
        if (!this.sideCategoriesContainer)
            return;
        this.categories = this.sideCategoriesContainer.querySelectorAll('li');
        this.addEventListeners();
    }
    addEventListeners() {
        this.categories.forEach((category) => {
            category.addEventListener('click', this.toggleCategory.bind(this));
        });
    }
    toggleCategory(event) {
        const target = event.currentTarget;
        if (target.classList.contains('current'))
            return;
        this.categories.forEach((category) => {
            if (category === target) {
                category.classList.toggle('active');
            }
            else if (category.classList.contains('active') && !category.classList.contains('current')) {
                category.classList.remove('active');
            }
        });
    }
}
